import React, { useState } from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Box,
    Avatar,
    Menu,
    MenuItem,
    Tooltip,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Divider,
    CssBaseline,
} from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PaymentsIcon from '@mui/icons-material/Payments';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// Mock user data
const mockUserData = {
    name: 'Shivamba',
    email: '',
};

// -----------------------------------------------------------------------------
// Header Component
// -----------------------------------------------------------------------------
const Udhariheader = ({ onMenuClick }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleLogout = () => {
        console.log('User signed out.');
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const userInitial = mockUserData?.name?.charAt(0)?.toUpperCase() || 'U';

    return (
        <AppBar
            position="fixed"
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                background: 'linear-gradient(90deg, #b5453fff 0%, #b78d3aff 50%, #b06927ff 100%)',
            }}
        >
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={onMenuClick} sx={{ mr: 2 }}>
                    <MenuIcon />
                </IconButton>

                <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
                    श्रीरामजी
                </Typography>

                <Box>
                    <Tooltip title="Profile">
                        <IconButton onClick={handleMenuOpen} size="small" sx={{ ml: 2 }}>
                            <Avatar sx={{ width: 32, height: 32 }}>
                                {userInitial}
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        onClick={handleMenuClose}
                        PaperProps={{
                            elevation: 3,
                            sx: { mt: 1.5 },
                        }}
                    >
                        <MenuItem disabled>
                            <Typography variant="subtitle1">
                                {mockUserData?.name || mockUserData?.email || 'Guest'}
                            </Typography>
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>
                            <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
                            बाहेर पडा
                        </MenuItem>
                        <MenuItem component={Link} to="/home">
                            मुख्यपृष्ठावर जा
                        </MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

// -----------------------------------------------------------------------------
// Sidebar Component
// -----------------------------------------------------------------------------
const drawerWidth = 240;

const Sidebar = ({ isOpen, onClose }) => {
    return (
        <Drawer
            variant="temporary"
            open={isOpen}
            onClose={onClose}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                    background: 'linear-gradient(to bottom, #9a0b0bff, #b45808ff)',
                    color: '#fff',
                    borderRight: 'none',
                },
            }}
            elevation={3}
        >
            <Toolbar />
            <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />

            <List component="nav">
                {/* Home */}
                <ListItemButton component={Link} to="/category/udhari" sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}>
                        <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="मुख्यपृष्ठ" />
                </ListItemButton>

                {/* Udhari Dene */}
                <ListItemButton component={Link} to="/udhari/udhari-dene" sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}>
                        <PaymentsIcon />
                    </ListItemIcon>
                    <ListItemText primary="उसने  देणे" />
                </ListItemButton>

                {/* Udhari Jama Karane */}
                <ListItemButton component={Link} to="/udhari/udhari-ghene" sx={styles.menuItem}>
                    <ListItemIcon sx={styles.menuIcon}>
                        <MonetizationOnIcon />
                    </ListItemIcon>
                    <ListItemText primary="उसने  घेणे " />
                </ListItemButton>
            </List>
        </Drawer>
    );
};

const styles = {
    menuItem: {
        px: 2,
        py: 1.5,
        color: '#fff',
        '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
    },
    menuIcon: { color: '#fff', minWidth: '40px' },
};

// -----------------------------------------------------------------------------
// Main App Component
// -----------------------------------------------------------------------------
const Index = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
    const theme = createTheme();

    return (
        <ThemeProvider theme={theme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <Udhariheader onMenuClick={toggleSidebar} />
                <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
            </Box>
        </ThemeProvider>
    );
};

export default Index;
